import Dropdown from 'bootstrap/js/src/dropdown.js'
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine.js'

const SELECTOR_UOE_NAV = '.uoe-nav-primary [data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)'

const refWidth = {
  name: 'edgelRefWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state }) {
    state.styles.popper.width = `${state.rects.reference.width}px`
  },
  effect({ state }) {
    state.elements.popper.style.width = `${
      state.elements.reference.offsetWidth
    }px`
  }
}

const WideDropdown = {
  getOrCreateInstance(element) {
    const config = {
      offset: [0, 0],
      popperConfig(defaultBsPopperConfig) {
        const widePopperConfig = {
          modifiers: [],
          ...defaultBsPopperConfig
        }
        widePopperConfig.modifiers.push(refWidth)

        return widePopperConfig
      }
    }

    const reference = element.closest('nav')
    if (reference) {
      config.reference = reference
    }

    return Dropdown.getOrCreateInstance(element, config)
  },
  configureEarly(selector) {
    for (const dropdown of SelectorEngine.find(selector)) {
      this.getOrCreateInstance(dropdown)
    }
  }
}

WideDropdown.configureEarly(SELECTOR_UOE_NAV)

export default WideDropdown
